const pickupLabels = [
    {
        title: 'Cliente',
        type: 'columns',
        fields: [
            {
                label: '[NOMBRECLIENTE]',
                description: 'customer_name',
                visible: true
            },
            {
                label: '[EMAILCLIENTE]',
                description: 'customer_email',
                visible: true
            },
            {
                label: '[DIRECCIONCLIENTE]',
                description: 'customer_address',
                visible: true
            },
            {
                label: '[TELEFONOCLIENTE]',
                description: 'customer_phone',
                visible: true
            },
            {
                label: '[MOVILCLIENTE]',
                description: 'customer_mobile',
                visible: true
            }
        ]
    },
    {
        title: 'Empresa y Agencia',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREEMPRESA]',
                description: 'company_name',
                visible: true
            },
            {
                label: '[NOMBREAGENCIA]',
                description: 'agency_name',
                visible: true
            },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            {
                label: '[EMAILAGENCIA]',
                description: 'agency_email',
                visible: true
            },
            {
                label: '[TELEFONOAGENCIA]',
                description: 'agency_phone',
                visible: true
            }
        ]
    },
    {
        title: 'Información Pickup',
        type: 'columns',
        fields: [
            {
                label: '[NUMEROPICKUP]',
                description: 'pickup_number',
                visible: true
            },
            {
                label: '[FECHAPICKUP]',
                description: 'pickup_date',
                visible: true
            },
            {
                label: '[HORASPICKUP]',
                description: 'pickup_hours',
                visible: true
            },
            {
                label: '[TIPOPAGOPICKUP]',
                description: 'pickup_payment_type',
                visible: true
            },
            {
                label: '[TIPOENVIOPICKUP]',
                description: 'pickup_shipping_type',
                visible: true
            },
            {
                label: '[NOTAPICKUP]',
                description: 'pickup_note',
                visible: true
            },
            {
                label: '[TIPOOPERACION]',
                description: 'operation_type',
                visible: true
            }
        ]
    },
    {
        title: 'Datos del Pickup',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREPICKUP]',
                description: 'pickup_name',
                visible: true
            },
            {
                label: '[DIRECCIONPICKUP]',
                description: 'pickup_address',
                visible: true
            },
            {
                label: '[TELEFONOPICKUP]',
                description: 'pickup_phone',
                visible: true
            },
            {
                label: '[MOVILPICKUP]',
                description: 'pickup_mobile',
                visible: true
            },
            {
                label: '[EMAILPICKUP]',
                description: 'pickup_email',
                visible: true
            }
        ]
    },
    {
        title: 'Datos de Entrega',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREENTREGA]',
                description: 'delivery_name',
                visible: true
            },
            {
                label: '[DIRECCIONENTREGA]',
                description: 'delivery_address',
                visible: true
            },
            {
                label: '[TELEFONOENTREGA]',
                description: 'delivery_phone',
                visible: true
            },
            {
                label: '[MOVILENTREGA]',
                description: 'delivery_mobile',
                visible: true
            },
            {
                label: '[EMAILENTREGA]',
                description: 'delivery_email',
                visible: true
            }
        ]
    },
    {
        title: 'Otros',
        type: 'columns',
        fields: [{ label: '[DETALLES]', description: 'details', visible: true }]
    }
];

export default pickupLabels;
